import React, { useEffect } from 'react';
import CSS from 'csstype';
import { Typography } from '@barpay/barpay-design-system';

const { H3 } = Typography;

export interface AdvertisementProps {
  show: boolean;
  adClientId: string;
  adSlotId: string;
  primary: boolean;
}

function Advertisement(props: AdvertisementProps) {
  useEffect(() => {
    if (!props.show) return;

    // Load the AdSense library if it hasn't been loaded yet
    const existingScript = document.querySelector(
      'script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]'
    );

    if (!existingScript) {
      const adScript = document.createElement('script');
      adScript.async = true;
      adScript.src =
        'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
      adScript.setAttribute('data-ad-client', props.adClientId);
      document.head.appendChild(adScript);
    }

    // Push to adsbygoogle to fill the ad slot
    try {
      ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push(
        {}
      );
    } catch (e) {
      // AdSense may throw if ad slot is already filled
    }
  }, [props.show, props.adClientId]);

  const adStyle: CSS.Properties = {
    display: 'block',
  };

  const devAdStyle: CSS.Properties = {
    display: 'block',
    border: '1px solid #f00',
  };

  let headerText = <H3 fontWeight={'normal'}>Menu Sponsored By:</H3>;

  if (!props.primary) {
    headerText = (
      <H3>
        This free contactless menu is made possible thanks to advertisers like:{' '}
      </H3>
    );
  }

  return !props.show ? (
    <React.Fragment></React.Fragment>
  ) : (
    <React.Fragment>
      {headerText}
      <ins
        className="adsbygoogle"
        style={
          process.env.REACT_APP_ENVIRONMENT === 'development'
            ? devAdStyle
            : adStyle
        }
        data-ad-client={props.adClientId}
        data-adtest="on"
        data-ad-slot={props.adSlotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </React.Fragment>
  );
}

export default Advertisement;
